/**
 * A random id for local list keys / client-side dedupe. `crypto.randomUUID`
 * needs a secure context, so fall back where it's missing (plain-http dev).
 */
export function newId(): string {
  return (
    globalThis.crypto?.randomUUID?.() ?? `id-${Date.now()}-${Math.random().toString(36).slice(2)}`
  );
}
